<prism-tooltip [text]="statusTooltip()" placement="top">
	<prism-status-indicator
		data-testid="state"
		*transloco="let t; read: 'scDeviceStateBar'"
		id="sh-device-state-bar"
		shape="rectangle"
		[attr.state]="prismState()"
		[status]="prismState()"
	></prism-status-indicator>
</prism-tooltip>
